// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lo-3";
export var downloadButton = "_lo-4";
export var fileContainer = "_lo-9 _lo-7";
export var fileContainerBase = "_lo-7";
export var fileContainerFixedHeight = "_lo-8 _lo-7";
export var fileInfo = "_lo-5";
export var fileInfoWidthRestricted = "_lo-6";
export var fileType = "_lo-1";
export var fileTypeName = "_lo-2";
export var image = "_lo-0";
export var link = "_lo-b";
export var overflowEllipsis = "_lo-a";